import React from 'react';

import { Box, Typography } from '@mui/material';

import { Button, Modal } from 'src/components/common';
import { Form } from 'src/components/finalForm';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const UserEmailChangeRequestConfirmModal: React.FC = () => {
  const { closeModal, isOpen, args } = useModal<{
    onSubmit: () => void;
  }>(ModalId.EmailChangeConfirm);

  const handleSubmitModal = React.useCallback(() => {
    args?.onSubmit?.();
    closeModal();
  }, [args, closeModal]);

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Confirmation Needed"
      dialogProps={{
        onClose: () => handleCloseModal(),
        open: isOpen,
      }}
      maxWidth={460}
    >
      <Typography variant="body2" fontSize="16px" mb={3}>
        A confirmation was sent to your current and new email addresses. Please check both emails
        and approve the change
      </Typography>

      <Form onSubmit={handleSubmitModal}>
        {({ submitting }) => (
          <Box display="flex" justifyContent="center" alignItems="center" gap={3}>
            <Button variant="outlined" color="error" onClick={handleCloseModal}>
              CANCEL
            </Button>
            <Button loading={submitting} variant="contained" type="submit">
              YES, SEND
            </Button>
          </Box>
        )}
      </Form>
    </Modal>
  );
};
